// Copyright (c) StrangeBee 2024

import { CustomFieldType } from 'thehive-sdk';

export const formatOptionValue = (value: string, type: CustomFieldType): string | number | null => {
    if (!value) {
        return null;
    }

    if (type === 'integer') {
        return parseInt(value, 10);
    } else if (type === 'float') {
        return parseFloat(value);
    }
    return value;
};

export const getOptions = (options: string, type: CustomFieldType): string[] | number[] => {
    const tab = Array.from(
        new Set(
            options.split('\n').reduce((acc, option) => {
                const trimmedOption = option.trim();
                if (trimmedOption !== '') {
                    return [...acc, trimmedOption];
                }
                return acc;
            }, [] as string[]),
        ),
    );

    if (type === 'integer' || type === 'float') {
        return tab.reduce((acc, option) => {
            const optionTested = formatOptionValue(option, type) as number;

            if (!isNaN(optionTested)) {
                return [...acc, optionTested];
            }

            return acc;
        }, [] as number[]);
    }

    return tab;
};

export const getAntdSelectOptions = (values: string[] = []): { label: string; value: string }[] =>
    values.sort((valueA, valueB) => valueA.localeCompare(valueB)).map((value) => ({ label: value, value: value }));
